let loginObj;

function handleCredentialResponse(response) {
  if (loginObj) {
    loginObj.handleCredentialResponse(response);
  }
}

function fetchWithAuthentication(url) {
  const headers = new Headers();
  const s = sessionStorage.getItem('auth-user-key');
  if (s != null) {
    const u = JSON.parse(s);
    if (u && u.accessToken) {
      const authToken = u.accessToken;
      headers.set('Authorization', `Bearer ${authToken}`);
    }
  }
  return fetch(url, {headers});
}

async function handleImageError(imageElement, resourceId) {
  if (!resourceId) {
    resourceId = imageElement.getAttribute("data-resource-id");
  }
  const imageUrl = "/api/student/resource/" + resourceId;

  const response = await fetchWithAuthentication(imageUrl);

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);

  if (imageElement.tagName.toLowerCase() === "img") {
    imageElement.src = objectUrl;
  } else {
    imageElement.style.background = "url('" + objectUrl + "')";
  }
  imageElement.onload = () => window.URL.revokeObjectURL(objectUrl);
  imageElement.onerror = undefined;
}
